module.exports = __webpack_public_path__ + "static/media/KHA-POC.b744e297.png";